import { Alert } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { TbInfoTriangle } from "react-icons/tb";

import CommonAlert from "@/components/CommonAlert";
import { useDeleteCustomPassengerMutation } from "@/requests/custom-passenger.mutations";
import { usePlanActions, usePlanShowDeletePassengerDialog } from "@/stores/use-plan-table";

function DeletePassengerDialog() {
    const { t } = useTranslation();
    const { mutateAsync, isPending } = useDeleteCustomPassengerMutation();

    const deletionInfo = usePlanShowDeletePassengerDialog();
    const { updatShowDeletePassengerDialog } = usePlanActions();
    const handleConfirm = async () => {
        if (isPending || !deletionInfo) return;
        try {
            const res = await mutateAsync(deletionInfo.id);
            enqueueSnackbar(t(res.message || ""), { variant: "success" });
        } catch (error) {
            console.error("IsDeletion error:", error);
        }
        handleClose();
    };

    const handleClose = () => {
        updatShowDeletePassengerDialog(null);
    };

    return (
        <CommonAlert
            open={!!deletionInfo}
            loading={isPending}
            description="confirmations.deletePassenger"
            color="error"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                name: deletionInfo?.name || "",
            }}
        >
            {deletionInfo?.taskAssigned && (
                <Alert icon={<TbInfoTriangle />} className="mt-2" severity="error">
                    {t("infos.passengerWillRemovedTasks")}
                </Alert>
            )}
        </CommonAlert>
    );
}

export default DeletePassengerDialog;
